// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contribution-notice {
    width: 100%;
    max-width: 800px;
    margin: 0 auto;
}
.contribution-notice .contribution-notice__logo {
    text-align: center;
}
.contribution-notice .contribution-notice__explanation {
    margin: 0 auto;
    font-size: 20px;
    line-height: 1.7em;
    text-align: center;
}
.contribution-notice .contribution-grid {
    display: grid;
    margin: 50px auto 0 auto;
    grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
    align-items: center;
    justify-items: center;

}
.contribution-notice .additional-contributions {
    margin: 20px auto;
    text-align: center;
}
.contribution-notice .contribution-notice__skip {
    text-align: center;
}
`, "",{"version":3,"sources":["webpack://./client/components/notices/ContributionNotice/ContributionNotice.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,wBAAwB;IACxB,2DAA2D;IAC3D,mBAAmB;IACnB,qBAAqB;;AAEzB;AACA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB","sourcesContent":[".contribution-notice {\n    width: 100%;\n    max-width: 800px;\n    margin: 0 auto;\n}\n.contribution-notice .contribution-notice__logo {\n    text-align: center;\n}\n.contribution-notice .contribution-notice__explanation {\n    margin: 0 auto;\n    font-size: 20px;\n    line-height: 1.7em;\n    text-align: center;\n}\n.contribution-notice .contribution-grid {\n    display: grid;\n    margin: 50px auto 0 auto;\n    grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\n    align-items: center;\n    justify-items: center;\n\n}\n.contribution-notice .additional-contributions {\n    margin: 20px auto;\n    text-align: center;\n}\n.contribution-notice .contribution-notice__skip {\n    text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
